// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Overlay_overlay__21RRv","transparent":"Overlay_transparent__371hS","opaque":"Overlay_opaque__82_Vy","empty":"Overlay_empty__PsVlc","loading":"Overlay_loading__1bNDa"};